export default function QnA() {
  return (
    <>
      <h2>Q&A</h2>
      <p>
        modi porro adipisci. Corporis rem blanditiis laudantium ab nobis ullam esse laboriosam
        mollitia. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab eum odio quod fuga
        itaque ducimus architecto delectus modi porro adipisci. Corporis rem blanditiis laudantium
        ab nobis ullam esse laboriosam mollitia.
      </p>
    </>
  );
}
